export default __webpack_public_path__ + "static/media/mobile.cc8d8615.png";